import { clamp, round } from 'lodash';

type Range = { min: number; max: number; decimals: number };

/** Whether a partially typed value can still become a valid number, e.g. `0.` or `.5` while typing `0.5` */
export function isSliderDraft(text: string, decimals: number): boolean {
	const fraction = decimals > 0 ? `(\\.\\d{0,${decimals}})?` : '';
	return new RegExp(`^\\d*${fraction}$`).test(text);
}

/** Typed value kept inside the slider's range and precision; undefined when nothing usable was typed */
export function parseSliderValue(text: string, { min, max, decimals }: Range): number | undefined {
	const value = Number.parseFloat(text);
	return Number.isFinite(value) ? round(clamp(value, min, max), decimals) : undefined;
}
